import { API_URL } from './networkEndpoints';
let reports = 0;
export function reportClientFailure(reason: unknown, componentStack = '') {
  const id = `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  const error = reason instanceof Error ? reason : new Error(typeof reason === 'string' ? reason : 'Unhandled browser error');
  const report = { id, message: error.message.slice(0, 1000), stack: (error.stack || '').slice(0, 4000), componentStack: componentStack.slice(0, 6000), path: window.location.pathname, userAgent: navigator.userAgent.slice(0, 500) };
  try { sessionStorage.setItem('pknin:last-client-error', JSON.stringify(report)); } catch {}
  if (reports++ < 3) {
    try {
      const jwt = localStorage.getItem('jwt');
      if (jwt) void fetch(`${API_URL}/client-diagnostics`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...report, jwt }), keepalive: true }).catch(() => {});
    } catch {}
  }
  return id;
}
export function installClientDiagnostics() {
  window.addEventListener('error', event => { if (event.error) reportClientFailure(event.error); });
  window.addEventListener('unhandledrejection', event => reportClientFailure(event.reason));
}
